import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Signing in...", -1)
const _hoisted_2 = [
  _hoisted_1
]

import { onMounted } from 'vue'
import { reloadApp, usePageTitle } from '@/util/AppUtil'
import { useTokenManager } from '@/auth/TokenManager'
import { LocalTokenApi } from './LocalTokenApi'
import { useTelemetry } from '@/util/Telemetry'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthRedirectPage',
  setup(__props) {

usePageTitle("Signing in")

const tokenManager = useTokenManager()
const { trackEvent } = useTelemetry()

async function exchangeToken() {
  const urlParams = new URLSearchParams(window.location.search)
  const accessToken = urlParams.get('access_token')
  const clientId = urlParams.get('client_id')
  const code = urlParams.get('code')

  if (accessToken) {
    await tokenManager.exchangeToken(accessToken)
  }
  else if (clientId && code) {
    const response = await LocalTokenApi.getLocalAccessTokenFromAuthCodeAsync(clientId, code)
    trackEvent('AuthCodeUsed')
    tokenManager.setCurrentTokenFromResponse(response)
  }

  let path = urlParams.get('redirect_uri')
  if (!path?.startsWith("/")) { // SECURITY: allow ONLY relative paths
    path = "/home"
  }

  // sign in complete, so navigate to target path
  reloadApp(path)
}

onMounted(() => {
  exchangeToken()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}
}

})